import { init } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"

import "./styles/index.css"

let inputSelector;
let formSelector;
let dropdownSelector;

if(window.innerWidth > 768) {
    inputSelector = ".header__search-bar .search__input.field__input";
    formSelector = ".header__search-bar .search.search-modal__form";
    dropdownSelector = "predictive-search";
} else {
    inputSelector = "#Search-In-Modal";
    formSelector = "#SearchDrawer .search.search-modal__form";
    dropdownSelector = "#SearchDrawer predictive-search";
}

const isNostoCollection = !document.getElementById("MainContent")?.classList?.contains("no-sort")
const isNostoSearch = !document.getElementById("MainContent")?.classList?.contains("no-sort");

const selectorsToRemove = ['.facets.facets-vertical-sort.page-width.small-hide', '.predictive-search.predictive-search--header'];
selectorsToRemove.forEach(selector => {
    // console.log(document.querySelectorAll(selector));
    document.querySelectorAll(selector).forEach(el => el.remove());
})

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    // historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: inputSelector,
    // contentCssSelector: ".facets-vertical.page-width",
    contentCssSelector: isNostoSearch ? ".facets-vertical.page-width" : undefined,
    // formCssSelector: formSelector,
    dropdownCssSelector: dropdownSelector,
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    serpPath: '/search',

    // Uncomment to redirect to search page instead of rewriting browser history
    serpPathRedirect: true,
    serpQuery: {
        products: {
            // fields: [
            //     "productId",
            //     "url",
            //     "name",
            //     "imageUrl",
            //     "thumbUrl",
            //     "description",
            //     "brand",
            //     "availability",
            //     "price",
            //     "priceText",
            //     "listPrice",
            //     "ratingValue",
            //     "reviewCount"
            //     'customFields.key', 'customFields.value'
            // ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            // fields: [
            //     "productId",
            //     "url",
            //     "name",
            //     "imageUrl",
            //     "thumbUrl",
            //     "brand",
            //     "availability",
            //     "price",
            //     "priceText",
            //     "listPrice",
            //     "ratingValue",
            //     "reviewCount"
            // ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,
    fallback: true,
    // // Uncomment for Category Merchandising
    categoryCssSelector: isNostoCollection ? '#shopify-section-template--15680832340073__product-grid' : undefined,
       categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                // categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
}).then(()=>{
    const input = document.querySelector(inputSelector);
    const bodyEl = document.body;
    if (input && bodyEl) {
        // Function to check if the input has a value
        function hasValue(inputElement) {
            return inputElement.value.trim() !== '';
        }

        if (hasValue(input)) {
            bodyEl.classList.add('nosto-input-focused');
        }

        // Add focus event listener
        input.addEventListener('focus', function() {
            bodyEl.classList.add('nosto-input-focused');
        });

        // Add blur event listener
        input.addEventListener('blur', function() {
            if (!hasValue(input)) {
                bodyEl.classList.remove('nosto-input-focused');
            }
        });

        // Add input event listener to check for changes
        input.addEventListener('input', function() {
            if (hasValue(input)) {
                bodyEl.classList.add('nosto-input-focused');
            } else {
                bodyEl.classList.remove('nosto-input-focused');
            }
        });
    }
})
